import React from "react";

const steps = [
  { number: "01", label: "SPU" },
  { number: "02", label: "SKU Preset: Variations" },
  { number: "03", label: "SKU Preset: Configurations" },
  { number: "04", label: "SKUs" }
];

export default function SpuProgressStepper({ currentStep = 1 }) {
  // % progress between circles
  const progressPercent = ((currentStep - 1) / (steps.length - 1)) * 100;

  return (
    <div className="spu-stepper-wrapper">

      {/* BACKGROUND BAR */}
      <div className="spu-stepper-line-background"></div>

      {/* PROGRESS BAR */}
      <div
        className="spu-stepper-line-progress"
        style={{ width: `${progressPercent}%` }}
      ></div>

      {/* STEPS */}
      <div className="spu-stepper-steps">
        {steps.map((step, index) => {
          const stepIndex = index + 1;
          const isActive = currentStep === stepIndex;
          const isCompleted = currentStep > stepIndex;

          return (
            <div key={index} className="spu-step-item">
              <div
                className={`spu-step-circle ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
              >
                {/* SVG CHECKMARK WHEN COMPLETED */}
                {isCompleted ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M15 4.5L6.75 12.75L3 9"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  step.number
                )}
              </div>

              <div
                className={`spu-step-label ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
              >
                {step.label}
              </div>
            </div>
          );
        })}
      </div>

      {/* ---------- RESPONSIVE CSS ---------- */}
      <style>{`
        .spu-stepper-wrapper {
          position: relative;
          padding: 20px 20px;
          background: white;
          border-radius: 10px;
          height: auto;
          display: flex;
          align-items: center;
        }

        /* BACKGROUND LINE */
        .spu-stepper-line-background {
          position: absolute;
          top: 35px;
          left: 15%;
          right: 15%;
          height: 2px;
          background: #e0e0e0;
          z-index: 1;
        }

        /* PROGRESS LINE */
        .spu-stepper-line-progress {
          position: absolute;
          top: 35px;
          left: 15%;
          height: 2px;
          background: #000;
          z-index: 2;
          transition: width 0.35s ease;
        }

        .spu-stepper-steps {
          width: 100%;
          display: flex;
          justify-content: space-between;
          position: relative;
          z-index: 3;
        }

        .spu-step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          min-width: 60px;
        }

        /* STEP CIRCLES */
        .spu-step-circle {
          width: 35px;
          height: 35px;
          border-radius: 20px;
          border: 2px solid #CED4DA;
          background: #FFF;

          color: #CED4DA;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background 0.3s ease;
        }

        /* ACTIVE (CURRENT) STEP */
        .spu-step-circle.active {
          background: #FFEB00;
          color: #000;
          border: 2px solid #FFEB00;
        }

        /* COMPLETED STEP — YELLOW + SVG ICON */
        .spu-step-circle.completed {
          background: #FFEB00;
          color: #000;
          border: 2px solid #FFEB00;
        }

        /* LABELS */
        .spu-step-label {
          margin-top: 8px;
          text-align: center;
          font-size: 16px;
          color: #6C757D;
          width: 100%;
          font-weight: 600;
          line-height: normal;
          font-family: 'Montserrat';
        }

        .spu-step-label.active {
          color: #212529;
        }

        .spu-step-label.completed {
          color: #212529;
        }

        /* ---------- MOBILE RESPONSIVENESS ---------- */
        @media (max-width: 600px) {
          .spu-stepper-wrapper {
            padding: 16px 10px;
          }

          .spu-step-circle {
            width: 30px;
            height: 30px;
            font-size: 16px;
          }

          svg {
            width: 18px;
            height: 18px;
          }

          .spu-step-label {
            font-size: 12px;
            max-width: 80px;
          }

          .spu-stepper-line-background,
          .spu-stepper-line-progress {
            top: 35px;
          }
        }
      `}</style>
    </div>
  );
}
